import React, { useEffect } from 'react'
import { useFieldArray } from 'react-hook-form'
import Button from '../General/Button'
import { HiOutlineDocumentAdd } from 'react-icons/hi'
import { FaRegTrashAlt } from 'react-icons/fa'

const FieldArrayPhone: React.FC<FieldArrayProps> = ({
  form,
  register,
  name,
  customDelete,
  customAdd,
  children,
  fieldLength = 5,
}) => {
  const { fields, append, remove } = useFieldArray({
    control: form?.control,
    keyName: '_id',
    name: name || '',
  })

  const getAddBtn = () =>
    customAdd
      ? React.cloneElement(customAdd, [
          {
            onClick: () => {
              append({})
            },
          },
          { htmlType: 'button' },
        ])
      : renderButton()
  const getDeleteBtn = (index) =>
    customDelete ? (
      React.cloneElement(customDelete, [
        { onClick: () => remove(index) },
        { htmlType: 'button' },
      ])
    ) : (
      <div
        onClick={() => remove(index)}
        className="mt-6 h-8 w-12 pl-5 bg-gray-100 col-span-1 cursor-pointer rounded-md text-primary-700 hover:text-danger border-2 border-gray-100 hover:border-red-400 relative dark:bg-gray-700 dark:border-gray-700"
      >
        <FaRegTrashAlt className="absolute top-1.5 left-3.5" />
      </div>
    )

  const renderButton = (): JSX.Element | null => {
    let button = (
      <Button
        small
        onClick={() => {
          append({})
        }}
        type="link"
        classes="mt-2 col-start-11 col-span-2 relative -top-3 lg:right-6 right-12 w-8 text-primary-400"
        htmlType="button"
        icon={<HiOutlineDocumentAdd />}
      >
        Agregar teléfono
      </Button>
    )

    return fields.length < fieldLength ? button : null
  }

  useEffect(() => {
    const _values = form.getValues()
    if (!_values.phones) {
      append({})
    }
  }, [append])

  return (
    <>
      {fields.map((item, index) => {
        return (
          <React.Fragment key={item._id}>
            {React.Children.map(children, (child: any) => {
              return React.cloneElement(child, {
                name: `${name}[${index}].${child.props.name}`,
                defaultValue:
                  child.props.name === 'country.id'
                    ? {
                        value: item.country?.id || 1,
                        text: item.country?.dialCode || item.country?.dial_code || '+58',
                      }
                    : item,
                form,
                register,
                error: form.error,
              })
            })}

            {index > 0 && getDeleteBtn(index)}
          </React.Fragment>
        )
      })}

      {getAddBtn()}
    </>
  )
}

export default FieldArrayPhone

interface FieldArrayProps {
  form?: any
  register?: Function
  name?: string
  customDelete?: any
  customAdd?: any
  fieldLength?: number
}
